interface ListItem {
	title: string;
	response?: string;
}

interface OverviewListProps {
	items: ListItem[];
}

export const OverviewList = (props: OverviewListProps) => {
	const { items } = props;

	return (
		<div className='w-full space-y-4'>
			{items.map((item, index) => (
				<div className='flex flex-row w-full items-center text-sm' key={index}>
					<div className='flex w-1/3'>
						<span className='text-gray-500'>{item.title}</span>
					</div>
					<div className='flex flex-1'>
						<span className='text-gray-900 font-semibold'>
							{item.response || '-'}
						</span>
					</div>
				</div>
			))}
		</div>
	);
};
